<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="Observaciones" key="1">
      <seguridad-salud-observaciones :id_case="id_case"/>
    </a-tab-pane>
    <a-tab-pane tab="Recomendaciones y/o Restricciones" key="2">
      <seguridad-salud-recommendcase :id_case="id_case"/>
    </a-tab-pane>
    <a-tab-pane tab="Seguimiento" key="3">
      <seguridad-salud-tracingcase :id_case="id_case"/>
    </a-tab-pane>
    <a-tab-pane tab="Documentos" key="4">
      <documentos :id_case="id_case"/>
    </a-tab-pane>
    <a-tab-pane tab="Instancias" key="5">
      <seguridad-salud-instance-cases :id_case="id_case"/>
    </a-tab-pane>
    <a-tab-pane tab="Examen Postincapacidad" key="6">
      <seguridad-salud-examen-postincapacidad :id_case="id_case"/>
    </a-tab-pane>
    <a-tab-pane tab="PCL" key="7">
      <pcl :id_case="id_case"/>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
    export default {
      props: ['id_case']
    }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/DetalleTabs.vue